import styled from "styled-components";

const ModalWr = styled.div`
  height: 100vh !important;
  background: #22222222 !important;
  backdrop-filter: blur(10px) !important;
`;
export default ModalWr;



// WEBPACK FOOTER //
// ./src/Components/Modal/ModalWr.js